export function urlFilter(value, type, scale = 50) {
  const reg = /http/;
  const file_url = 'http://file.nidong.com';
  if (reg.test(value)) return value;
  if (process.env.NODE_ENV == 'development') {
    // value = "http://psdfile-dev.b0.upaiyun.com" + "/" + value;
    if (
      value != null &&
      typeof value == 'string' &&
      value.substr(0, 1) == '/'
    ) {
      if (type === 'video') {
        value = file_url + '/' + value;
      } else {
        value = file_url + value + '!/scale/' + scale;
      }
    } else {
      value = file_url + '/' + value;
    }
  } else {
    if (
      value != null &&
      typeof value == 'string' &&
      value.substr(0, 1) == '/'
    ) {
      if (type === 'video') {
        value = file_url + '/' + value;
      } else {
        value = file_url + value + '!/scale/' + scale;
      }
    } else {
      value = file_url + '/' + value;
    }
  }
  return value;
}

export function audioFilter(value, type, scale = 50) {
  const reg = /http/;
  const file_url = 'http://file.nidong.com';
  if (reg.test(value)) return value;
  value = file_url + value;
  return value;
}

export const dateFormatter = (nows) => {
  if (!nows) return '';
  var now = new Date(nows);
  var year = now.getFullYear();

  var month = now.getMonth() + 1;
  month = checkAddZone(month);

  var date = now.getDate();
  date = checkAddZone(date);
  return year + '-' + month + '-' + date;
};

function checkAddZone(num) {
  return num < 10 ? '0' + num.toString() : num;
}

export function dateTimeFormatter(t, type) {
  if (!t) return '';
  t = new Date(t).getTime();
  t = new Date(t);
  // var year = t.getFullYear()
  var month = t.getMonth() + 1;
  // month = checkAddZone(month)

  var date = t.getDate();
  // date = checkAddZone(date)

  var hour = t.getHours();
  hour = checkAddZone(hour);

  var min = t.getMinutes();
  min = checkAddZone(min);

  // var se = t.getSeconds()
  // se = checkAddZone(se)
  if (!type) {
    return month + '月' + date + '日' + hour + ':' + min;
  }
  if (type == 'm-d') {
    return month + '月' + date + '日';
  }
  if (type == 'h-m') {
    return hour + ':' + min;
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  // console.log((time+'').length)
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    // if (("" + time).length === 10) {
    //     time = parseInt(time) * 1000
    // } else {
    //     if (
    //         /Safari/.test(navigator.userAgent) &&
    //         !/Chrome/.test(navigator.userAgent) &&
    //         ("" + time).length != 10 &&
    //         ("" + time).length != 13
    //     ) {
    //         time = time.replace(/-/g, "/")
    //     }
    // }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a')
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function timesOut(time, cFormat) {
  if (time <= 0) {
    return '00:00:00';
  }
  if (!time) {
    return '00:00:00';
  }
  var hour = parseInt(time / 1000 / 60 / 60);
  var sec =
    parseInt((time / 1000 / 60) % 60) > 10
      ? parseInt((time / 1000 / 60) % 60)
      : '0' + parseInt((time / 1000 / 60) % 60);
  var min =
    (time / 1000) % 60 > 10
      ? parseInt((time / 1000) % 60)
      : '0' + parseInt((time / 1000) % 60);
  var time_str = hour + ':' + sec + ':' + min;
  return time_str;
}

export function DateAdd(interval, number, date) {
  switch (interval) {
    case 'y': {
      date.setFullYear(date.getFullYear() + number);
      return date;
      break;
    }
    case 'q': {
      date.setMonth(date.getMonth() + number * 3);
      return date;
      break;
    }
    case 'm': {
      date.setMonth(date.getMonth() + number);
      return date;
      break;
    }
    case 'w': {
      date.setDate(date.getDate() + number * 7);
      return date;
      break;
    }
    case 'd': {
      date.setDate(date.getDate() + number);
      return date;
      break;
    }
    case 'h': {
      date.setHours(date.getHours() + number);
      return date;
      break;
    }
    case 'min': {
      date.setMinutes(date.getMinutes() + number);
      return date;
      break;
    }
    case 's': {
      date.setSeconds(date.getSeconds() + number);
      return date;
      break;
    }
    default: {
      date.setDate(date.getDate() + number);
      return date;
      break;
    }
  }
}

export function changeVal(test, val, web) {
  if (web) {
    var newTest = test
    if (typeof val == "string" || typeof val === 'number') {
      newTest = newTest.replace("{d}", `<span class="web">${val}</span>`)
    } else {
      for (let i = 0; i < val.length; i++) {
        newTest = newTest.replace("{d}", `<span class="web">${val[i]}</span>`)
      }
    }
  } else {
    var newTest = test
    if (typeof val == "string" || typeof val === 'number') {
      newTest = newTest.replace("{d}", val)
    } else {
      for (let i = 0; i < val.length; i++) {
        newTest = newTest.replace("{d}", val[i])
      }
    }
  }
  return newTest
}

export function AddressParameter(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export function timeType(val) {
  var h = parseInt(val / 3600)
  var s = parseInt((val - (h * 3600)) / 60)
  var m = parseInt(val - (h * 3600) - (s * 60))
  s = s < 10 ? '0' + s : s;
  m = m < 10 ? '0' + m : m;
  return h + ":" + s + ":" + m
}

export function deepClone(data) {
  var type = typeof data;
  var obj;
  if (type === 'array') {
    obj = [];
  } else if (type === 'object' && data != null) {
    obj = {};
  } else {
    // 不再具有下一层次
    return data;
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
}
// 货币格式(截取小数点后两位)
export function moneyFormat(money) {
  if (money && money != null) {
    money = String(money);
    var left = money.split('.')[0],
      right = money.split('.')[1];
    right = right
      ? right.length >= 2
        ? '.' + right.substr(0, 2)
        : '.' + right + '0'
      : '.00';
    var temp = left
      .split('')
      .reverse()
      .join('')
      .match(/(\d{1,3})/g);
    return (
      (Number(money) < 0 ? '-' : '') +
      temp
        .join(',')
        .split('')
        .reverse()
        .join('') +
      right
    );
  } else {
    //注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return '0.00';
  }
}

//   魅力值/豪气值处理
export function richsCharmsrule(value, list) {
  let data = '';
  if (value) {
    list.forEach((item, index) => {
      if (
        (item.price < value || item.price == value) &&
        value < list[index + 1].price
      ) {
        data = item.remark;
      }
    });
  }
  return data;
}

export function getCookie(cookie_name) {
  var allcookies = document.cookie;
  //索引长度，开始索引的位置
  var cookie_pos = allcookies.indexOf(cookie_name);

  // 如果找到了索引，就代表cookie存在,否则不存在
  if (cookie_pos != -1) {
    // 把cookie_pos放在值的开始，只要给值加1即可
    //计算取cookie值得开始索引，加的1为“=”
    cookie_pos = cookie_pos + cookie_name.length + 1;
    //计算取cookie值得结束索引
    var cookie_end = allcookies.indexOf(';', cookie_pos);

    if (cookie_end == -1) {
      cookie_end = allcookies.length;
    }
    //得到想要的cookie的值
    var value = unescape(allcookies.substring(cookie_pos, cookie_end));
  }
  return value;
}

// 充值跳转
export function recharge() {
  let ua = navigator.userAgent;
  let isIOS = /(iPhone|iPads|iPod)/i.test(ua);
  if (isIOS) {
    window.location.href = 'native://?module=User&action=gotoCoinRecharge'
  } else {
    window.location.href = 'native://?path=user/coinInvite&androidUrl=/user/recharge'
  }
}

export function goChat(userId) {
  window.location.href =
    "native://?className=PSMyDetailInfoController&androidUrl=/user/viewHomepage&userId=" +
    userId +
    "&change=1";
}